import {createSlice} from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "authentication",
  initialState: {
    isAuthenticated: false,
    user: null
  },
  reducers: {
    signIn: (state, action) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.isAuthenticated = true;
      state.user = action.payload;
    },
    signout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
    }
  },
});

// Action creators are generated for each case reducer function
export const {signIn, signout} = authSlice.actions;

export default authSlice.reducer;